import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import paintBurshIcon from 'assets/icons/paint_brush_broad.svg';
import { usePageFilters } from 'customHooks/usePageFilters';
import { CreativesFilters, CreativeStatus } from 'components/common/types/Creative.types';
import { Store } from 'components/common/types/Store.types';
import MetricsWidget from '../MetricsWidget';

const PendingCreativesMetrics: React.FC = () => {
  const numberOfPendingCreatives = useSelector(
    (state: Store) => state.pages.contentManagement.creatives.pendingCreativesCount,
  )?.toString();
  const navigate = useNavigate();

  const { changeFilters } = usePageFilters<CreativesFilters>('content-management/creatives');

  return (
    <div className="relative flex w-full h-20 group">
      <div
        className="w-full h-full absolute group-hover:cursor-pointer"
        role="presentation"
        data-test-id="pending-creatives-overlay"
        onClick={() => {
          changeFilters({ status: [CreativeStatus.PENDING] });
          navigate('/content-management/creatives');
        }}
      />
      <MetricsWidget
        name="Creatives pending approval"
        value={numberOfPendingCreatives === undefined ? '-' : numberOfPendingCreatives}
        icon={paintBurshIcon}
        isLoaderVisible={numberOfPendingCreatives === undefined}
      />
    </div>
  );
};

export default PendingCreativesMetrics;
